import React from 'react';
import MyNavbar from '../components/MyNavbar';
import Footer from '../components/Footer';
import { Container, Row, Col, Card } from 'react-bootstrap';

const Research = () => {
  return (
    <div>
      <MyNavbar />
      <section style={{
        backgroundColor: '#0A4B5D',
        color: 'white',
        paddingTop: '5rem',
        paddingBottom: '3rem'
      }}>
        <Container>
          <Row className="text-center">
            <Col lg={8} className="mx-auto">
              <h1 className="display-4 fw-bold mb-4">Research</h1>
              <p className="lead">
                Dr. Trupti Joshi’s research integrates biomedical informatics, multiomics data analysis,
                and artificial intelligence to drive innovation in precision medicine and precision agriculture.
              </p>

            </Col>
          </Row>
        </Container>
      </section>
      <div style={{ paddingTop: '100px', minHeight: '80vh' }}>
        <Container>
          <Row xs={1} md={2} className="g-4">
            <Col>
              <Card className="h-100 shadow border-0">
                <Card.Body className="p-4">
                  <Card.Title style={{ color: '#0A4B5D' }}>Knowledge Base Frameworks</Card.Title>
                  <Card.Text>
                    Development of scalable knowledge base platforms such as <strong>KBCommons</strong> and
                    <strong> SoyKB</strong> for genomics and multiomics data integration in biomedical and agricultural research.
                    These frameworks support thousands of global users and provide comprehensive multiomics resources.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col>
              <Card className="h-100 shadow border-0">
                <Card.Body className="p-4">
                  <Card.Title style={{ color: '#0A4B5D' }}>Computational Methodologies</Card.Title>
                  <Card.Text>
                    Design of computational pipelines and analytical tools utilizing
                    <strong> high-performance computing (HPC)</strong> and cloud-based infrastructure
                    for efficient multiomics data processing and integration.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col>
              <Card className="h-100 shadow border-0">
                <Card.Body className="p-4">
                  <Card.Title style={{ color: '#0A4B5D' }}>Deep Learning & AI Models</Card.Title>
                  <Card.Text>
                    Application of <strong>deep learning</strong> and <strong>machine learning</strong> approaches
                    for biomarker identification, phenotype prediction, and translational bioinformatics.
                    Projects include <em>G2PDeep</em> and <em>IRnet</em> frameworks for multiomics-driven discoveries.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col>
              <Card className="h-100 shadow border-0">
                <Card.Body className="p-4">
                  <Card.Title style={{ color: '#0A4B5D' }}>Integrative Multiomics Analysis</Card.Title>
                  <Card.Text>
                    Creation of <strong>multiomics integration algorithms</strong> to reveal complex biological
                    relationships across genomics, transcriptomics, proteomics, and metabolomics data—advancing
                    insights in human health and plant science.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col>
              <Card className="h-100 shadow border-0">
                <Card.Body className="p-4">
                  <Card.Title style={{ color: '#0A4B5D' }}>IMPRes Algorithm</Card.Title>
                  <Card.Text>
                    Development of the <strong>IMPRes (Integrative MultiOmics Pathway Resolution)</strong> algorithm
                    for <em>in silico</em> hypothesis generation and translational research, enabling pathway-level
                    biological inference from integrated datasets.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col>
              <Card className="h-100 shadow border-0">
                <Card.Body className="p-4">
                  <Card.Title style={{ color: '#0A4B5D' }}>Translational Bioinformatics</Card.Title>
                  <Card.Text>
                    Applying informatics and AI to bridge <strong>precision medicine, precision agriculture,
                      and genomic epidemiology</strong>—including COVID-19 variant surveillance and
                    data-driven health analytics.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <div className="text-center mt-5">
            <p>
              <strong>Learn more:</strong><br />
              <a href="https://scholar.google.com/citations?user=Pyt_mlAAAAAJ&hl=en&oi=ao" target="_blank" rel="noopener noreferrer">
                Google Scholar
              </a>{' '}
              |{' '}
              <a href="https://www.ncbi.nlm.nih.gov/myncbi/trupi.joshi.1/bibliography/public/" target="_blank" rel="noopener noreferrer">
                PubMed
              </a>{' '}
              |{' '}
              <a href="https://www.linkedin.com/in/trupti-joshi-9552ba17/" target="_blank" rel="noopener noreferrer">
                LinkedIn
              </a>
            </p>
          </div>
        </Container>
      </div>
      <Footer />
    </div>
  );
};

export default Research;
